import querySelectorDomUtil from 'utils/dom/query-selector'
import logUtil from 'utils/log'

export default function scrollToTopQuickShopUtil () {
  logUtil('scrollToTopQuickShopUtil').debug('[start]')

  const element = querySelectorDomUtil('.quick-shop-product-sidebar-wrapper')
  if (!element) {
    logUtil('scrollToTopQuickShopUtil').debug('[noop] no element')
    return
  }

  element.scrollTo({
    top: 0,
    behavior: 'smooth'
  })

  logUtil('scrollToTopQuickShopUtil').debug('[done]')
}
